<template>
  <b-card>
    <b-row
      align-h="end"
      class="mr-0 mb-1"
    >
      <b-col cols="auto">
        <envio-email-em-lote
          :empresas-selecionadas="empresasSelecionadasGrid"
          :empresas-grid="empresasGrid"
          title="Enviar DAS MEI por e-mail"
          nome-arquivo="DASMEI"
          alterar-style="font-size: 11.5px; height: 32px; display: inline-flex; align-items: center;"
          :evento="enviarEmailEmLote"
          :evento-verificar-email="verificarEmail"
        />
      </b-col>
      <b-col cols="auto">
        <download-em-excel
          :filtro="filtroAtual"
          tipo="PgMei"
          alterar-style="font-size: 11.5px;padding: .65rem 2rem;"
          :api="apiPgMei"
          :desabilitado="empresasSelecionadasGrid.length === 0"
          :get-info-extra="montarDto"
        />
      </b-col>
      <b-col cols="auto">
        <download-em-lote
          tipo-arquivo="todos DAS"
          tipo="PG MEI "
          :filtro="filtroAtual.filtroBy"
          alterar-style="font-size: 11.5px;padding: .45rem 1rem;"
          @baixar-lote="baixarEmLote"
        />
      </b-col>
    </b-row>
    <pg-mei-list
      ref="pgMeiList"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :tem-filtro-rapido="false"
      @carregado="dadosGrid = $event"
      @selected-rows-change="empresasSelecionadasGrid = $event"
    >
      <template
        slot="custom"
        slot-scope="{ props }"
      >
        <b-badge
          v-if="props.column.field === 'paga'"
          :variant="props.row[props.column.field] ? 'light-success' : 'light-danger'"
        >
          {{ props.row[props.column.field] ? 'Sim' : 'Não' }}
        </b-badge>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          @atualizar-grid="atualizarGrid"
        />
      </template>
    </pg-mei-list>
  </b-card>
</template>

<style lang="scss">
.col-tamanho-cnpj {
  min-width: 194px !important;
}
</style>

<script>
import notificarBaixaLote from '@app/shared/utils/baixaEmLoteToast'
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import colunas from './config/colunas'
import filtrosRapidosConfig from './config/filtrosRapidos'
import api from './services/api'

export default {
  name: 'PgMeiView',
  components: {
    PgMeiList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
    DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
    EnvioEmailEmLote: () => import('@app/shared/components/envio-email-lote/EnvioEmailEmLote.vue'),
  },
  data() {
    return {
      apiPgMei: api,
      botoesOption: null,
      visualizacao: {
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: false,
        placeholderBusca: 'Buscar por Razão Social, CNPJ/CPF',
        colunas,
        evento: this.carregar,
      },
      filtros: [{ colunas: ['CadastroFederal', 'RazaoSocial', 'CadastroFederalSemMascara'], valor: null }],
      filtrosRapidos: filtrosRapidosConfig,
      filtroAtual: {},
      dadosGrid: [],
      empresasSelecionadasGrid: [],
    }
  },
  computed: {
    empresasGrid() {
      return this.dadosGrid
    },
  },
  created() {
    this.visualizacao.colunas = colunas
    this.visualizacao.evento = this.carregar
    this.visualizacao.allpaged = this.allPaged
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    verificarEmail(ids) {
      return api.verificarEmail(ids)
    },

    enviarEmailEmLote(nomeArquivo, emails) {
      return api.enviarEmLote(nomeArquivo, emails)
    },

    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          try {
            const statusResp = await envioHistoricoApi.obterStatus(29, ids) // 29 = ETipoRotina.PGMei
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },

    allPaged(filtro) {
      return api.getTodasLinhas(filtro)
    },

    baixarEmLote(evt) {
      const empresas = this.empresasSelecionadasGrid?.length
        ? this.empresasSelecionadasGrid
        : (this.$refs.pgMeiList?.linhaSelecionada || [])
      const filtro = {
        ...this.filtroAtual,
        empresasSelecionadas: empresas,
      }
      notificarBaixaLote(api.baixaEmLote(filtro, evt))
    },

    atualizarGrid() {
      this.$refs.pgMeiList.refresh()
    },

    montarDto() {
      const empresas = this.empresasSelecionadasGrid?.length
        ? this.empresasSelecionadasGrid
        : (this.$refs.pgMeiList?.linhaSelecionada || [])
      return {
        ...this.filtroAtual,
        empresasSelecionadas: empresas,
      }
    },

    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.pgMeiList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.pgMeiList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
  },
}
</script>
